/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type UserTokenMainQueryRendererQueryVariables = {
    lang: string;
    prefixes?: Array<string | null> | null | undefined;
};
export type UserTokenMainQueryRendererQueryResponse = {
    readonly translationList: {
        readonly translations: ReadonlyArray<{
            readonly component: string | null;
            readonly text: string | null;
        } | null> | null;
    } | null;
    readonly languageList: {
        readonly languages: ReadonlyArray<{
            readonly language: string | null;
            readonly languageId: string | null;
        } | null> | null;
    } | null;
};
export type UserTokenMainQueryRendererQuery = {
    readonly response: UserTokenMainQueryRendererQueryResponse;
    readonly variables: UserTokenMainQueryRendererQueryVariables;
};



/*
query UserTokenMainQueryRendererQuery(
  $lang: String!
  $prefixes: [String]
) {
  translationList(lang: $lang, prefixes: $prefixes) {
    translations {
      component
      text
    }
  }
  languageList {
    languages {
      language
      languageId
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "lang"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "prefixes"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "lang",
        "variableName": "lang"
      },
      {
        "kind": "Variable",
        "name": "prefixes",
        "variableName": "prefixes"
      }
    ],
    "concreteType": "TranslationList",
    "kind": "LinkedField",
    "name": "translationList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Translation",
        "kind": "LinkedField",
        "name": "translations",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "component",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "text",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "LanguageList",
    "kind": "LinkedField",
    "name": "languageList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Language",
        "kind": "LinkedField",
        "name": "languages",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "language",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "languageId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserTokenMainQueryRendererQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserTokenMainQueryRendererQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "586d50aca22c71357558ed5e4b96fcb8",
    "id": null,
    "metadata": {},
    "name": "UserTokenMainQueryRendererQuery",
    "operationKind": "query",
    "text": "query UserTokenMainQueryRendererQuery(\n  $lang: String!\n  $prefixes: [String]\n) {\n  translationList(lang: $lang, prefixes: $prefixes) {\n    translations {\n      component\n      text\n    }\n  }\n  languageList {\n    languages {\n      language\n      languageId\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'aefbac228ce83e4a95d40f13d89c9d8f';
export default node;
